export const getDevice = (state) => {
    return state.device;
};
export const getDevicePixel = (state) => {
    return state.pixel;
};